import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input } from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import update from 'react-addons-update';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
const FormItem = Form.Item;
let dragingIndex = -1;
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Qscode extends Component {

	constructor(props) {
		super(props)
		this.state = {
			name: '',
			departmentName: '',
			bootcampId: '',
			sharePath:'',
			visible: false,
			token: '',
			url: '',
			modelTitel: '新增海报模板',
			subjectIcon: '',
			introduction: '',
			dataSource: [],
			notChanged: [],
			bootcList: [],
			qiuniuUrl: '',
			qrcodeId: null,
			searchData: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			},
			columns: [
				{
					title: '海报',
					dataIndex: 'shareTemplateImgUrl',
					key: 'shareTemplateImgUrl',
					align: 'center',
					render: (record)=> <img src={record} style={{width: '40px',height: '40px'}} alt=""/>
				},
				{
					title: '海报模板名称',
					dataIndex: 'departmentName',
					key: 'departmentName',
					align: 'center'
				},
				// {
				// 	title: '创建人',
				// 	dataIndex: 'admin',
				// 	key: 'admin',
				// 	align: 'center'
				// },
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '发布状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					render: (record,text)=> {
						if(text.status === 0) {
							return (
								<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
									Modal.confirm({
										title: '发布',
										okText: "确认",
										cancelText: "取消",
										content: (
											<div>
												<p>发布一段时间（大概30分钟）后用户端可见，确定要发布吗？</p>
											</div>
										),
										onOk: () => {
											this.releasePosters(text.id)
										},
									});
								}}>未发布</span>
							)
						}
						if(text.status === 1) {
							return (
								<span>发布中</span>
							)
						}
						if(text.status === 2) {
							return (
								<span>发布完成</span>
							)
						}
						if(text.status === 3) {
							return (
								<span>部分发布失败</span>
							)
						}
						if(text.status === 4) {
							return (
								<span>全部发布失败</span>
							)
						}
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						{record.status === 0 ? <span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}}  onClick={() => {
							this.setState({
								visible: true,
								modelTitel: '编辑海报模板',
								departmentName: record.departmentName,
								bootcampId: record.bootcampId,
								sharePath:record.sharePath,
								qrcodeId: record.id,
								subjectIcon: {
									uid: null,
									type: null,
									url: record.shareTemplateImgUrl,
									name: record.departmentName
								},

							})
						}}>编辑</span> : ''}
						{record.status !== 1 ? <span style={{color: '#277FFF', cursor: 'pointer'}} onClick={() => {
							Modal.confirm({
								title: '删除海报模板',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delQscode(record.id)
								},
							});
						}}>删除</span> : ''}
					</div>
				},
			]
		}
	}
	handleOk=(e)=> {
		this.props.form.validateFields((err, values) => {
			if(!err) {
				if(this.state.modelTitel === '编辑海报模板'){
					let pic = values.qscode.url&&values.qscode.url ? values.qscode.url :this.state.qiuniuUrl +'/'+ values.qscode.response.key
					axios.post('shareTemplateController/update',{
						departmentName: values.departmentName,
						bootcampId: values.bootcampId,
						sharePath:values.sharePath,
						shareTemplateImgUrl: pic,
						id: this.state.qrcodeId
					}).then( res => {
						if(res.data.code === '200') {
							this.setState({visible: false})
							message.success('修改成功')
							this.getList()
						}else{
							message.error(res.data.msg)
						}
					})
				}else {
					axios.post('shareTemplateController/add',{
						departmentName: values.departmentName,
						bootcampId: values.bootcampId,
						sharePath:values.sharePath,
						shareTemplateImgUrl: this.state.url +'/'+ values.qscode.response.key,
					}).then( res => {
						if(res.data.code === '200') {
							this.setState({visible: false})
							message.success('新增成功')
							this.getList()
						}else{
							message.error(res.data.msg)
						}
					})
				}
				
			}
		});
	}
	releasePosters(id) {
		axios.get(`shareTemplateController/sync/${id}`).then(res => {
			if(res.data.code === '200') {
				message.success('发布成功')
				this.getList()
			}else {
				message.success(res.data.msg)
			}
		})
	}
	componentDidMount() {
		this.getList()
		this.getToken()
		this.getBootList()
	}
	showModal() {
		this.setState({
			visible: true,
			modelTitel: '新增海报模板',
			subjectIcon: ''
		 })
	}
	async getList() {
		axios.post('shareTemplateController/getList',{
			...this.state.searchData,
			departmentName: this.state.name
		}).then( res => {
			if(res.data.code === '200'){
				this.setState({
					dataSource: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
						total: res.data.data.total
					}
				})
			}
		})
	}
	delQscode(id) {
		axios.get(`shareTemplateController/del/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.getList()
			}else {
				message.error(res.data.msg)
			}
		})
	}
	getBootList() {
		axios.post('/bootcamp/list', {}).then(res => {
			if(res.data.code === '200'){
				this.setState({
					bootcList: res.data.data.list
				})
			}
		})
	}
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				// this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	components ={
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => {
		const { dataSource } = this.state;
		const dragRow = dataSource[dragIndex];
		this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
	
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
		axios.post('/shareTemplateController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' ){
				this.getList()
				message.success('更新排序成功')
			}else {
				message.error(res.data.msg)
			}
			oldSort = []
		})
	};
	render() {
		
		const { visible, dataSource, columns, modelTitel, subjectIcon, name, departmentName, sharePath,searchData } = this.state;
		const { getFieldDecorator } = this.props.form
		const pagination ={
			showSizeChanger: true,
			total: searchData.total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${searchData.total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getList(searchData)
			},
		}
		return (
			<div>
				<span style={{display: 'flex', alignItems: 'center',fontSize: '18px',fontWeight: '600'}}>专属海报</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between',marginBottom: '20px' }}>
					<div>
						<Input allowClear value={name} style={{width: '260px',height: '40px',marginRight: '20px'}} placeholder="请输入名称" onChange={(e)=>{
							this.setState({
								name: e.target.value
							})
						}}></Input>
						<Button className='my-button-primary' style={{marginRight: '20px'}} onClick={()=>{
							this.getList()
						}} type='primary'>搜索</Button>
						<span className='my-button-txt' onClick={()=>{
							this.setState({name: ''},()=>{
								this.getList()
							})
						}} type='primary'>重置</span>
					</div>
					<Button className='my-button-primary' type='primary'  onClick={() => { this.showModal() }}>新增海报</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table pagination={pagination} dataSource={dataSource}
						columns={columns}
						components={this.components}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						rowKey={record => record.id}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
					/>
				</DndProvider>
				<Modal
					getContainer={false}
					title={modelTitel}
					okText="确认"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<FormItem label={"海报名称"}>
							{getFieldDecorator('departmentName', {initialValue: modelTitel==='编辑海报模板'? departmentName: '',
								rules: [{ required: true, message: '请输入海报名称!' },{max: 20, message: '最多输入20个字符'}],
							})(
								<Input allowClear placeholder='请输入海报名称' />
							)}
						</FormItem>
						<Form.Item label="海报模板">
							{getFieldDecorator('qscode', {
								initialValue: modelTitel==='编辑海报模板'? subjectIcon: '',
								rules: [{ required: true, message: '请上传模板图片!' }],
							})(
								// <div>
									<UploadQiniu getQiniuUrl={this.getQiniuUrl}/>
									// <p style={{color: '#999999',fontSize: '12px',lineHeight: 1.5,marginTop: '5px'}}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*144px</p>
								// </div>
							)}
						</Form.Item>
						<FormItem label={"跳转链接"}>
							{getFieldDecorator('sharePath',{
								initialValue: modelTitel==='编辑海报模板'? sharePath: ''})(
								<Input allowClear placeholder='请输入跳转链接' />
							)}
						</FormItem>
						{/* <FormItem label="训练营" style={{marginTop: '-20px'}}>
							{getFieldDecorator('bootcampId', {
								initialValue: modelTitel==='编辑海报模板'? bootcampId: ''
										})(
							<Select placeholder="学科" allowClear style={{ width: 140,  marginRight: '20px' }} >
												<Option value={0}>全部</Option>
								{this.state.bootcList.map(item => {
									return (<Option key={item.id + item.name} value={item.id}>{item.name}</Option>)
								})}
							</Select>
						)}
						</FormItem> */}
						{/* <FormItem label={"海报简介"}>
							{getFieldDecorator('introduction',{
								initialValue: modelTitel==='编辑海报'? introduction: '',
								rules: [{max: 200, message: '最多输入200个字符'}]})(
								<TextArea allowClear  style={{width: '100%'}}  placeholder='请输入海报简介' />
							)}
						</FormItem> */}
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(Qscode)
